/** @format */

const phoneCondition = (number, regularExpressions = []) =>
  /^\+\d{5,}$/.test(number) ||
  regularExpressions.some((regex) => regex.test(number));

const simCodeCondition = (code) =>
  /^[A-Z0-9]{2}-[A-Z0-9]{2}-[A-Z0-9]{2}-[A-Z0-9]{2}$/.test(code);

export { phoneCondition, simCodeCondition };
